import {
  anchorColorCount,
  getColorSelections
} from '~/selectors/ProductSelectors';
import {
  goalQuantity,
  profitsJS,
  salePricesJS
} from '~/selectors/FundraisingSelectors';

export function quoteServiceSerialize(state) {
  const product_ids = getColorSelections(state);
  const color_counts = anchorColorCount(state);
  const quantity = goalQuantity(state);
  const prices = salePricesJS(state);
  const profits = profitsJS(state);

  const items = product_ids.map(productId => {
    return {
      color_counts: color_counts,
      items: [
        {
          product_id: productId,
          quantity: quantity
        }
      ]
    };
  });

  const quote_params = {
    items: items,
    prices: prices,
    profits: profits
  };

  return JSON.stringify(quote_params);
}

export function printMinimumSerialize(productId, state) {
  const color_counts = anchorColorCount(state);
  const prices = salePricesJS(state);
  const productData = {
    id: productId,
    price: prices[productId],
    front_colors_count: color_counts['front'],
    back_colors_count: color_counts['back'] || 0
  };
  return {product: productData};
}
